import script from "./BaseTemplateComponent.vue?vue&type=script&lang=js"
export * from "./BaseTemplateComponent.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__